import { Clients } from "../../types/enums";
import { LoanTypeForFields } from "../enums";
import { BRIDGE_V2_ID } from "./versions";


const bridgeV2 = {
  id: BRIDGE_V2_ID,
  [Clients.BPL_SIZER]: {
    inputFields: {
      borrowerInformation: [
        "propertiesCompletedWithinLast36Months",
        "foreignNational",
        "ImmigrationStatus",
        "originalCreditScore",
        "InState",
      ],
      loanInformation: [
        "OriginatorLoanID",
        "LoanStructure",
        "LoanPurpose",
        "CashOutFlag",
        "ExitStrategy",
        "pledgeOfEquity",
      ],
      loanEconomics: [
        "InitialLoanAmount",
        "OrgInterestRate",
        "TotalRehabBudget",
        "financedBudget",
        "TotalOrgAndDiscountPoints",
      ],
      propertyLocation: ["address", "postalCode", "city", "state"],
      propertyInformation: [
        "propertyType",
        "ExpansionOrChangeOfUseCase",
        "ValuationSource",
        "PercentOccupied",
      ],
      propertyEconomics: [
        "orgAppraisalValue",
        "purchasePrice",
        "ClosingCost",
        "AsRepairedValueARV",
        "EstimatedRentPerYearUponCompletion",
        "costBasis",
        "AssignmentFee",
        "annualPropertyTaxes",
        "annualInsurance",
        "annualHOAFee",
      ],
      loanFeatures: ["OriginalAsIsLtv", "originalAsRepairedLTV", "OriginalLtc"],
      loanCharacterization: [
        "CustomerTypeExperiencedNew",
        "PurchaseOrRefinance",
        "rehabType",
        "StabilizedFlag",
        "loanCharacterization",
      ],
      propertyLoanFeatures: [
        "cbsa",
        "MedianValue",
        "LtmHpa",
        "DaysOnMarket",
        "ESRIPopulationDensity",
      ],
    },
    outputFields: {},
  },
  [Clients.MMTC]: {
    inputFields: {
      borrowerInformation: {
        quickLoanSizing: [],
        [LoanTypeForFields.MULTIFAMILYMIXEDUSE]: [
          "propertiesCompletedWithinLast36Months",
          "BorrowerGuarantor",
          "ImmigrationStatus",
          "originalCreditScore",
        ],
        [LoanTypeForFields.SFR]: [],
        [LoanTypeForFields.UNIT_24]: [],
        [LoanTypeForFields.CONDO]: [],
        [LoanTypeForFields.TOWNHOME]: [],
      },
      loanInformation: {
        quickLoanSizing: [],
        [LoanTypeForFields.MULTIFAMILYMIXEDUSE]: [
          "OriginatorLoanID",
          "LoanStructure",
          "LoanPurpose",
          "recourse",
          "ExitStrategy",
          "LoanTerm",
          "CashOutFlag",
          "requiredInterestReserve",
          "requiredInterestReserveMonths"
        ],
        [LoanTypeForFields.SFR]: [],
        [LoanTypeForFields.UNIT_24]: [],
        [LoanTypeForFields.CONDO]: [],
        [LoanTypeForFields.TOWNHOME]: [],
      },
      loanEconomics: {
        quickLoanSizing: [],
        [LoanTypeForFields.MULTIFAMILYMIXEDUSE]: [
          "exitDebt",
          "hardCosts",
          "softCostsCap15Rehab",
          "TotalRehabBudget",
          "InitialLoanAmount",
          "TotalOrgAndDiscountPoints",
          "interestRate",
          "financedBudget",
          "includeOutOfPocketBudgetARLTV",

        ],
        [LoanTypeForFields.SFR]: [],
        [LoanTypeForFields.UNIT_24]: [],
        [LoanTypeForFields.CONDO]: [],
        [LoanTypeForFields.TOWNHOME]: [],
      },
      propertyLocation: {
        quickLoanSizing: [],
        [LoanTypeForFields.MULTIFAMILYMIXEDUSE]: ["address", "postalCode", "city", "state"],
        [LoanTypeForFields.SFR]: ["address", "postalCode", "city", "state"],
        [LoanTypeForFields.UNIT_24]: ["address", "postalCode", "city", "state"],
        [LoanTypeForFields.CONDO]: ["address", "postalCode", "city", "state"],
        [LoanTypeForFields.TOWNHOME]: ["address", "postalCode", "city", "state"],
      },
      propertyInformation: {
        quickLoanSizing: [],
        [LoanTypeForFields.MULTIFAMILYMIXEDUSE]: [
          "propertyType",
          "noOfUnits",
          "ExpansionOrChangeOfUseCase",
          "ValuationSource",
          "PercentOccupied",
          "isPurchasedWithDebt"
        ],
        [LoanTypeForFields.SFR]: [],
        [LoanTypeForFields.UNIT_24]: [],
        [LoanTypeForFields.CONDO]: [],
        [LoanTypeForFields.TOWNHOME]: [],
      },
      propertyEconomics: {
        quickLoanSizing: [],
        [LoanTypeForFields.MULTIFAMILYMIXEDUSE]: [
          "orgAppraisalValue",
          "purchasePrice",
          "borrowerPaidCostToDate",
          "AsRepairedValueARV",
          "EstimatedRentPerYearUponCompletion",
          "appraisalStabilizedNOI",
          "annualPropertyTaxes",
          "costBasis",
          "grossCondoSelloutValue",
          "AssignmentFee",
          "purchaseDate",
          "annualInsurance",
          "annualHOAFee"
        ],
        [LoanTypeForFields.SFR]: [],
        [LoanTypeForFields.UNIT_24]: [],
        [LoanTypeForFields.CONDO]: [],
        [LoanTypeForFields.TOWNHOME]: [],
      },
      loanFeatures: {
        quickLoanSizing: [],
        [LoanTypeForFields.MULTIFAMILYMIXEDUSE]: ["OriginalAsIsLtv", "originalAsRepairedLTV", "OriginalLtc"],
        [LoanTypeForFields.SFR]: [],
        [LoanTypeForFields.UNIT_24]: [],
        [LoanTypeForFields.CONDO]: [],
        [LoanTypeForFields.TOWNHOME]: [],
      },
      loanCharacterisation: {
        quickLoanSizing: [],
        [LoanTypeForFields.MULTIFAMILYMIXEDUSE]: [
          "CustomerTypeExperiencedNew",
          "PurchaseOrRefinance",
          "rehabType",
          "StabilizedFlag",
          "loanCharacterization",
        ],
        [LoanTypeForFields.SFR]: [],
        [LoanTypeForFields.UNIT_24]: [],
        [LoanTypeForFields.CONDO]: [],
        [LoanTypeForFields.TOWNHOME]: [],
      },
      propLoanFeatures: {
        quickLoanSizing: [],
        [LoanTypeForFields.MULTIFAMILYMIXEDUSE]: [
          "cbsa",
          "MedianValue",
          "LtmHpa",
          "DaysOnMarket",
          "ESRIPopulationDensity",
        ],
        [LoanTypeForFields.SFR]: [],
        [LoanTypeForFields.UNIT_24]: [],
        [LoanTypeForFields.CONDO]: [],
        [LoanTypeForFields.TOWNHOME]: [],
      },
      marketData: {
        quickLoanSizing: [],
        [LoanTypeForFields.MULTIFAMILYMIXEDUSE]: [
          "MarketName",
          "CapRate",
          "TwelveMonthRentalGrowth",
          "RentPerSqFt",
          "RentPerUnit",
          "SalePriceGrowth",
          "SalePricePerUnit",
          "Population",
          "VacancyRate",
        ],
        [LoanTypeForFields.SFR]: [],
        [LoanTypeForFields.UNIT_24]: [],
        [LoanTypeForFields.CONDO]: [],
        [LoanTypeForFields.TOWNHOME]: [],
      },
      subMarketData: {
        quickLoanSizing: [],
        [LoanTypeForFields.MULTIFAMILYMIXEDUSE]: [
          "SubMarketName",
          "CapRate",
          "TwelveMonthRentalGrowth",
          "RentPerSqFt",
          "RentPerUnit",
          "SalePriceGrowth",
          "SalePricePerUnit",
          "VacancyRate"
        ],
        [LoanTypeForFields.SFR]: [],
        [LoanTypeForFields.UNIT_24]: [],
        [LoanTypeForFields.CONDO]: [],
        [LoanTypeForFields.TOWNHOME]: [],
      },
    },
    outputFields: {},
  },
};

export default bridgeV2;
